import { CommandBarButton, MessageBarType } from "office-ui-fabric-react";
import React, { Component, Fragment } from "react";
import Actions from "../redux/Actions";
import { IRootState } from "../store";
import DispatchProps from "../utils/DispatchProps";
import ServiceAccountCredentials from "../models/ServiceAccountCredentials";
import School from "../models/School";
import ApiService from "./ApiService";
import {connect} from "react-redux";
import UpdateSchoolPage from "./pages/admin/UpdateSchoolPage";

interface UpdateSchoolCredentialsProps {
    school: School;
    apiService: ApiService;
}

interface UpdateSchoolCredentialsState {
    serviceAccountCredentials?: ServiceAccountCredentials;
    saveButtonDisabled: boolean;
}

class UpdateSchoolCredentials extends Component<UpdateSchoolCredentialsProps & DispatchProps, UpdateSchoolCredentialsState> {

    constructor(props: UpdateSchoolCredentialsProps & DispatchProps) {
        super(props);

        this.state = {
            serviceAccountCredentials: {},
            saveButtonDisabled: true
        };
    }

    componentDidMount(): void {
        if (this.props.school) {
            this.loadSchoolCredentials();
        }
    }

    async componentDidUpdate(prevProps: Readonly<UpdateSchoolCredentialsProps & DispatchProps>, prevState: Readonly<UpdateSchoolCredentialsState>, snapshot?: any): Promise<void> {
        if (this.props.school !== prevProps.school) {
            await this.loadSchoolCredentials();
        }
    }

    private async loadSchoolCredentials(): Promise<void> {
        try {
            this.setState({ saveButtonDisabled: true });

            const username = await this.props.apiService.getServiceAccountUsername(this.props.school.tenantId!, this.props.school.schoolCode!);
            
            this.setState({
                serviceAccountCredentials: {
                    username: username
                }
            });
            this.setState({ saveButtonDisabled: false });
        }
        catch (e) {
            this.setState({
                serviceAccountCredentials: { },
                saveButtonDisabled: false
            });
            
            console.log(e);
            this.props.dispatch(Actions.showMessageBar("Unable to load service account credentials, do they exist?", MessageBarType.error));
            return;
        }
    }

    protected submitForm = async () => {
        try {
            this.setState({ saveButtonDisabled: true });

            await this.props.apiService.putServiceAccountCredentials(this.props.school.tenantId!, this.props.school.schoolCode!, this.state.serviceAccountCredentials!);

            this.props.dispatch(Actions.showMessageBar("Service account credentials updated successfully", MessageBarType.success));
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar("Service account credentials save request failed", MessageBarType.error));
        }
        this.setState({ saveButtonDisabled: false });
    };
    
    render(): JSX.Element {
        
        var suggestedServiceAccountUpn = `CDB_${this.props.school!.schoolCode!.toUpperCase()}_Service_Account@${this.props.school.tenantName}.onmicrosoft.com`
        var usernameDescription = `Usually matches the automated service account : ${suggestedServiceAccountUpn}`;
        
        return (
            <Fragment>
                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Update Service Account Credentials</span>

                        <CommandBarButton
                            iconProps={{ iconName: "save" }}
                            text="Save"
                            disabled={this.state.saveButtonDisabled}
                            onClick={this.submitForm}
                        />
                    </div>
                    <div className="card__content flex-column">
                        {UpdateSchoolPage.createSchoolFormField(this,"serviceAccountCredentials", "username", "Username", { disabled: false, required: true ,description: usernameDescription})}
                        {UpdateSchoolPage.createSchoolFormField(this,"serviceAccountCredentials", "password", "Password", { disabled: false, required: false, type: "password", description: "If blank, current password will not be updated" })}
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { school: School }): UpdateSchoolCredentialsProps => {
        return {
            school: ownProps.school,
            apiService: state.auth.apiService,
        };
    }
)(UpdateSchoolCredentials);